function navigateScreen(ROUTES_NAME, id) {  
    try {
        window.location.replace(ROUTES_NAME + (id != null || '' ? `/?${id}` : ''));
    }
    catch {
        console.log('Error to navigate screen!');
    }
}

export default navigateScreen